/* eslint-disable no-useless-escape */
import {
  codigoPaquete,
  nombresPaquetes,
  codigosTarjetas,
} from "@/config/constantes/paquetes";
import MobileDetect from 'mobile-detect';

/**
 * Obtejer categoría para el pixel de acuerdo al paquete
 * @param {Object} caracteristicasPaquete
 */
export const _getCategoria = (caracteristicasPaquete) => {
  let tipoPaquete = caracteristicasPaquete.tipoPaquete;
  if (tipoPaquete == codigoPaquete.TARJETA_SUELTA) {
    // Para tarjeta suelta devolvemos nombre de tarjeta
    switch (caracteristicasPaquete.tarjetas[0].tipoTarjeta) {
      case codigosTarjetas.VISA_GOLD:
      case codigosTarjetas.MASTERCARD_GOLD:
        return "Gold";
      case codigosTarjetas.VISA_INTERNACIONAL:
        return "Inter";

      default:
        return "";
    }
  }
  // Devolver nombre de paquete
  return nombresPaquetes(tipoPaquete);
};

/**
 * Obtejer parámetro "valor" para el pixel de acuerdo al paquete
 * @param {Object} caracteristicasPaquete
 */
export const _getValor = (caracteristicasPaquete) => {
  let tipoPaquete = caracteristicasPaquete.tipoPaquete;
  switch (tipoPaquete) {
    case codigoPaquete.LIBRETON_EXPRESS:
      return "500";
    case codigoPaquete.LIBRETON_FULL:
      return "576";
    case codigoPaquete.LIBRETON_PLUS_GOLD:
      return "384";
    case codigoPaquete.LIBRETON_PREMIUM:
      return "1153";
    case codigoPaquete.LIBRETON_PREMIUM_WORLD:
      return "1538";
    // case codigoPaquete.TARJETA_SUELTA:
    //   if( tipoTarjeta == codigosTarjetas.VISA_GOLD || tipoTarjeta == codigosTarjetas.MASTERCARD_GOLD ){
    //     return '2600'
    //   }
    //   if( tipoTarjeta == codigosTarjetas.VISA_INTERNACIONAL ){
    //     return '2500';
    //   }
    // break;
    default:
      return "";
  }
};

/**
 * Verificar por el userAgent si el dispositivo es
 * mobile o no
 */
export const _isMobile = () => {
  const md = new MobileDetect(window.navigator.userAgent);
  return md.mobile() !== null;
};

/**
 * Obtener el nombre del motor para tagging
 */
export const nombreMotorTagging = () => {
  let campania = process.env.VUE_APP_CAMP || "ofertaDigital";
  if (campania == "ofertaDigital") {
    return "on line";
  }
  return campania.replace("oferta", "").toLowerCase();
};

/**
 * Obtener el nombre del motor para pixeles
 */
export const nombreMotorPixeles = () => {
  let campania = process.env.VUE_APP_CAMP || "ofertaDigital";
  if (campania == "ofertaDigital") {
    return "ofertasDigitales";
  }
  return campania;
};
